import React from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { NavTitle } from './style';

const { SubMenu } = Menu;

function MenuItems({ darkMode, toggleCollapsed, topMenu }) {
	const { path } = useRouteMatch();
	const pathName = window.location.pathname;
	const pathArray = pathName.split(path);
	const mainPath = pathArray[1];
	const mainPathSplit = mainPath.split('/');
	const [openKeys, setOpenKeys] = React.useState(
		!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'finance'}`] : [],
	);

	const onOpenChange = (keys) => {
		setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
	};

	const onClick = (item) => {
		if (item.keyPath.length === 1) setOpenKeys([]);
	};

	return (
		<Menu
			onOpenChange={onOpenChange}
			onClick={onClick}
			mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
			theme={darkMode && 'dark'}
			// // eslint-disable-next-line no-nested-ternary
			defaultSelectedKeys={
				!topMenu
					? [
						`${mainPathSplit.length === 1
							? 'playing'
							: mainPathSplit.length === 2
								? mainPathSplit[1]
								: mainPathSplit[2]
						}`,
					]
					: []
			}
			defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'finance'}`] : []}
			overflowedIndicator={<FeatherIcon icon="more-vertical" />}
			openKeys={openKeys}
		>
			<SubMenu key="finance" icon={!topMenu && <FeatherIcon icon="home" />} title="Finance">
				<Menu.ItemGroup key="plaid" title={<div className="menu-item-group">Plaid</div>}>
					<Menu.Item key="plaid-balance">
						<NavLink onClick={toggleCollapsed} to={`${path}/plaid/balance`}>
							Balance
						</NavLink>
					</Menu.Item>
					<Menu.Item key="plaid-holdings">
						<NavLink onClick={toggleCollapsed} to={`${path}/plaid/investment-holdings`}>
							Investment holdings
						</NavLink>
					</Menu.Item>
					<Menu.Item key="plaid-investment-transactions">
						<NavLink onClick={toggleCollapsed} to={`${path}/plaid/investment-transactions`}>
							Investment holdings
						</NavLink>
					</Menu.Item>
					<Menu.Item key="plaid-payments">
						<NavLink onClick={toggleCollapsed} to={`${path}/plaid/payments`}>
							Payments
						</NavLink>
					</Menu.Item>
				</Menu.ItemGroup>
				<Menu.ItemGroup key="zoho" title={<div className="menu-item-group">Zoho Books</div>}>
					<Menu.Item key="sales-orders">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/sales-orders`}>
							Sales Orders
						</NavLink>
					</Menu.Item>

					<Menu.Item key="invoice-liste">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/invoices`}>
							Invoices
						</NavLink>
					</Menu.Item>
					<Menu.Item key="invoice-creation">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/create-invoice`}>
							Create Invoice
						</NavLink>
					</Menu.Item>
					<Menu.Item key="customer-payments">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/customer-payments`}>
							Customer Payments
						</NavLink>
					</Menu.Item>
					<Menu.Item key="expenses">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/expenses`}>
							Expenses
						</NavLink>
					</Menu.Item>
					<Menu.Item key="employees">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/employees`}>
							Employees
						</NavLink>
					</Menu.Item>
					<Menu.Item key="bills">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/bills`}>
							Bills
						</NavLink>
					</Menu.Item>
					<Menu.Item key="create-bills">
						<NavLink onClick={toggleCollapsed} to={`${path}/zoho/create-bill`}>
							Create Bill
						</NavLink>
					</Menu.Item>
				</Menu.ItemGroup>
				<Menu.ItemGroup key="quickbooks" title={<div className="menu-item-group">QuickBooks</div>}>
					<Menu.Item key="quickbooks-">
						<NavLink onClick={toggleCollapsed} to={`${path}/quickbooks`}>
							Reports
						</NavLink>
					</Menu.Item>
				</Menu.ItemGroup>
			</SubMenu>

			<SubMenu key="project" icon={!topMenu && <FeatherIcon icon="home" />} title="Project management">
				<Menu.Item key="trello">
					<NavLink onClick={toggleCollapsed} to={`${path}/project-management/trello/getboard`}>
						Trello
					</NavLink>
				</Menu.Item>
				<Menu.Item key="asana">
					<NavLink key="asana" onClick={toggleCollapsed} to={`${path}/project-management/asana/getproject`}>
						Asana
					</NavLink>
				</Menu.Item>
			</SubMenu>

			{/* <SubMenu key="intercom" icon={!topMenu && <FeatherIcon icon="home" />} title="Intercom">
				<Menu.Item key="intercomusers">
					<NavLink key="intercomusers" onClick={toggleCollapsed} to={`${path}/intercom/users`}>
						Users
					</NavLink>
				</Menu.Item>
				<Menu.Item key="intercomconversations">
					<NavLink key="intercomconversations" onClick={toggleCollapsed} to={`${path}/intercom/conversations`}>
						Conversations
					</NavLink>
				</Menu.Item>
			</SubMenu> */}

			<SubMenu key="api-tool" icon={!topMenu && <FeatherIcon icon="home" />} title="API tools">
				<Menu.Item key="adobe">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/adobe`}>
						Adobe
					</NavLink>
				</Menu.Item>
				<Menu.Item key="spotify">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/spotify`}>
						Spotify
					</NavLink>
				</Menu.Item>
				<Menu.Item key="elasticsearch">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/elasticsearch`}>
						ElasticSearch
					</NavLink>
				</Menu.Item>
				<Menu.Item key="airtable">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/airtable`}>
						Airtable
					</NavLink>
				</Menu.Item>
				<Menu.Item key="eventbrite">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/eventbrite`}>
						Eventbrite
					</NavLink>
				</Menu.Item>
				<Menu.Item key="wolfram">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/wolfram`}>
						Wolfram Alpha
					</NavLink>
				</Menu.Item>
				<Menu.Item key="clarifai">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/clarifai`}>
						Clarifai
					</NavLink>
				</Menu.Item>
				<Menu.Item key="surveymonkey">
					<NavLink onClick={toggleCollapsed} to={`${path}/api-tool/surveymonkey`}>
						Survey Monkey
					</NavLink>
				</Menu.Item>
				<Menu.ItemGroup key="intercom" title={<div className="menu-item-group">Intercom</div>}>
					<Menu.Item key="intercomusers">
						<NavLink key="intercomusers" onClick={toggleCollapsed} to={`${path}/intercom/users`}>
							Users
						</NavLink>
					</Menu.Item>
					<Menu.Item key="intercomconversations">
						<NavLink key="intercomconversations" onClick={toggleCollapsed} to={`${path}/intercom/conversations`}>
							Conversations
						</NavLink>
					</Menu.Item>
				</Menu.ItemGroup>
			</SubMenu>
		</Menu>
	);
}

MenuItems.propTypes = {
	darkMode: propTypes.bool,
	topMenu: propTypes.bool,
	toggleCollapsed: propTypes.func,
};

export default MenuItems;
